import { IPostingsWithWidgetQuery } from '../interfaces/interfaces/postings-with-widget.query.interface';
import { Posting } from 'app/library/posting/models/posting.model';

export class PostingsWithWidget {
    widget: { id: string; name: string };
    postings: Posting[];

    constructor(postingsWithGroupQuery: IPostingsWithWidgetQuery) {
        this.widget = { id: String(postingsWithGroupQuery.widget.id), name: postingsWithGroupQuery.widget.name };
        this.postings = postingsWithGroupQuery.postings.map((posting) => new Posting(posting));
    }
}
